/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import {
   FaUser,
   FaSignOutAlt,
   FaChevronDown,
   FaChevronUp,
   FaIdBadge,
   FaLock,
} from 'react-icons/fa';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UserPhoto, UserNavContainer, UserDropdown, StatusBadge } from './UserInfoStyled';
import * as actions from '../../store/modules/auth/actions';

export default function UserInfo({
   user = {},
   isLoggedIn = false,
   collapsed = false,
   onNavigate,
}) {
   const dispatch = useDispatch();
   const [dropdownOpen, setDropdownOpen] = useState(false);

   const handleLogout = (e) => {
      e.preventDefault();
      e.stopPropagation();

      const response = window.confirm('Tem certeza que deseja sair?');
      if (!response) return;

      if (onNavigate) onNavigate();
      dispatch(actions.logoutRequest());
   };

   const toggleDropdown = () => {
      if (!collapsed) {
         setDropdownOpen(!dropdownOpen);
      }
   };

   // Estado não logado
   if (!isLoggedIn) {
      return (
         <UserNavContainer $collapsed={collapsed} $isLoggedIn={false}>
            <div className="guest-container">
               <div className="guest-icon">
                  <FaUser size={collapsed ? 20 : 24} />
               </div>
               {!collapsed && (
                  <div className="guest-info">
                     <p className="guest-title">Visitante</p>
                     <p className="guest-subtitle">Faça login para acessar</p>
                  </div>
               )}
            </div>
         </UserNavContainer>
      );
   }

   // Estado logado - versão colapsada (apenas avatar)
   if (collapsed) {
      return (
         <UserNavContainer $collapsed={collapsed} $isLoggedIn={isLoggedIn}>
            <div className="user-avatar-wrapper">
               <StatusBadge $online title="Online" />
               <UserPhoto
                  $collapsed={collapsed}
                  title={user?.nome ? `Usuário: ${user.nome}` : 'Usuário'}
               />
            </div>
         </UserNavContainer>
      );
   }

   // Estado logado - versão expandida
   return (
      <UserNavContainer $collapsed={collapsed} $isLoggedIn={isLoggedIn}>
         <div className="user-frame">
            {/* Header com avatar e status */}
            <div className="user-header" onClick={toggleDropdown} role="button" tabIndex={0}>
               <div className="user-avatar-wrapper">
                  <StatusBadge $online title="Online" />
                  <UserPhoto
                     $collapsed={collapsed}
                     title={user?.nome ? `Usuário: ${user.nome}` : 'Usuário'}
                  />
               </div>

               <div className="user-info">
                  <p className="user-name">{user.nome || 'Usuário'}</p>
               </div>

               <div className="dropdown-toggle">
                  {dropdownOpen ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
               </div>
            </div>

            {/* Dropdown com informações e logout */}
            <div className={`dropdown-wrapper ${dropdownOpen ? 'open' : ''}`}>
               <UserDropdown>
                  <div className="user-details">
                     <div className="detail-item">
                        <span className="detail-label">ID:</span>
                        <span className="detail-value">{user.id}</span>
                     </div>
                     <div className="detail-item">
                        <span className="detail-label">Perfil de Acesso:</span>
                        <span className="detail-value">{user.role_name || 'Usuário'}</span>
                     </div>
                  <p className="user-role">{user.email || ''}</p>
                  </div>

                  {/* Conta do próprio usuário — sem RBAC, disponível a todos.
                      `Link` real (não button com navigate): abre em nova aba
                      com o botão do meio e é acessível (FC7 §G.3). */}
                  <div className="account-actions">
                     <Link
                        to="/account/profile"
                        className="account-link"
                        onClick={onNavigate}
                     >
                        <FaIdBadge size={15} />
                        <span>Meu perfil</span>
                     </Link>

                     <Link
                        to="/account/password"
                        className="account-link"
                        onClick={onNavigate}
                     >
                        <FaLock size={15} />
                        <span>Alterar minha senha</span>
                     </Link>
                  </div>

                  <button
                     type="button"
                     className="logout-button"
                     onClick={handleLogout}
                     title="Sair do sistema"
                  >
                     <FaSignOutAlt size={16} />
                     <span>Sair</span>
                  </button>
               </UserDropdown>
            </div>
         </div>
      </UserNavContainer>
   );
}

UserInfo.propTypes = {
   user: PropTypes.object,
   isLoggedIn: PropTypes.bool,
   collapsed: PropTypes.bool,
   onNavigate: PropTypes.func,
};
